// extracted by mini-css-extract-plugin
export default {"wrap":"rp-z","logoContainer":"sp-z","brandImg":"tp-z","logoImg":"up-z","logoButton":"vp-z"};